

import state from './moduleLevelState.js'
import mutations from './moduleLevelMutations.js'
import actions from './moduleLevelActions.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
